export const ANTICIPATION_RULE = 'ANTICIPATION_RULE';
export const AUTOMATIC_ANTICIPATION_ENABLED = 'AUTOMATIC_ANTICIPATION_ENABLED';
export const ANTICIPATION_REQUEST_PENDING = 'ANTICIPATION_REQUEST_PENDING';
export const ANTICIPATION_TAX = 'ANTICIPATION_TAX';
export const ANTICIPATIONS_AVAILABLE = 'ANTICIPATIONS_AVAILABLE';
export const ANTICIPATIONS_AVAILABLE_COUNT = 'ANTICIPATIONS_AVAILABLE_COUNT';
export const ANTICIPATIONS_AVAILABLE_LOADING = 'ANTICIPATIONS_AVAILABLE_LOADING';
export const SELECTED_ANTICIPATIONS = 'SELECTED_ANTICIPATIONS';
export const SELECTED_ANTICIPATIONS_AMOUNT = 'SELECTED_ANTICIPATIONS_AMOUNT';
export const ANTICIPATIONS_AVAILABLE_LIMIT = 'ANTICIPATIONS_AVAILABLE_LIMIT';
export const ANTICIPATIONS_AVAILABLE_PAGE = 'ANTICIPATIONS_AVAILABLE_PAGE';
export const CURRENT_TAX = 'CURRENT_TAX';
export const BALANCE = 'BALANCE';
export const WEEKLY_SCHEDULE = 'WEEKLY_SCHEDULE';
export const SUMMARY = 'SUMMARY';
export const BILLING_CHART = 'BILLING_CHART';
export const PAYMENT_KIND = 'PAYMENT_KIND';
export const AVERAGE_TICKET = 'AVERAGE_TICKET';
